import React, {Component} from 'react';
import couterpart from 'counterpart';
import "react-table/react-table.css";
import {FaRegSave} from 'react-icons/fa';
import { ICON_COLOR } from '../icon';
import '../css/style.css';
import { Multiselect } from 'multiselect-react-dropdown';

import AuthenticationService from '../services/AuthenticationService';
import MasterDataService from '../services/MasterDataService';
import {ToastsContainer, ToastsStore} from 'react-toasts';

class ShippingCalendar extends Component{
    constructor() {
        super();
        this.state = {
            id: 0,
            calendar: '1,4',
            duration: 7,
            shipTo: '',
            selectedDays: [
                { id: 1, name: 'Thứ ba'},
                { id: 4, name: 'Thứ sáu'},
            ],
            days: [
                { id: 0, name: 'Thứ hai'},
                { id: 1, name: 'Thứ ba'},
                { id: 2, name: 'Thứ tư'},
                { id: 3, name: 'Thứ năm'},
                { id: 4, name: 'Thứ sáu'},
                { id: 5, name: 'Thứ bảy'},
                { id: 6, name: 'Chủ nhật'},
            ],
        };
    };

    componentDidMount () {
        MasterDataService.fetchShippingCalendar().then(data => {
            if (data.message === undefined){ 
                this.setState({
                    id: data.id,
                    calendar: data.calendar,
                    duration: data.duration,
                    shipTo: data.shipTo
                });
            }
        });
    }

    handleChange(e){
        var name = e.target.name;
        var value = e.target.value;
        this.setState({ [name]:  value});
    }

    handleSave(){
        let answ = window.confirm(couterpart.translate('msg_calendar_save_confirm'));
        if (answ){
            if (this.state.selectedDays === undefined || this.state.selectedDays === null || this.state.selectedDays.length < 1){
                ToastsStore.error(couterpart.translate('msg_calendar_day_missing'));
                return;
            }

            if (this.state.duration === undefined || this.state.duration === null || this.state.duration < 1){
                ToastsStore.error(couterpart.translate('msg_calendar_duration_missing'));
                return;
            }

            let days = '';
            let sep = '';
            for(let i=0; i<this.state.selectedDays.length; i++){
                days += sep + this.state.selectedDays[i].id;
                sep = ','; 
            }

            let info = {
                id: this.state.id,
                duration: this.state.duration,
                calendar: days
            }

            if ((this.state.id != null) && (this.state.id > 0)){
                MasterDataService.updateShippingCalendar(info).then(data => {
                    ToastsStore.info(couterpart.translate("msg_saved_info"));
                });
            }else{
                ToastsStore.error(couterpart.translate('msg_saved_error'));
            }
        }
    }

    onSelect(selectedList, selectedItem) {
        this.setState({
            selectedDays: selectedList
        });
    }
    
    onRemove(selectedList, removedItem) {
        this.setState({
            selectedDays: selectedList
        });    
    }      

    render(){
        if(!AuthenticationService.isAdmin()){
            return (<div>Unauthorized access.</div>);
        }
        
        return (
            <div>
                <h4>{couterpart.translate('shipping_calendar')}</h4>
                <div className="row">
                    <div className="col-12">
                        <div className="row" style={{ marginTop: "5px"}}>
                            <div className="col-2">
                                { couterpart.translate('shipping_calendar_day') }:
                            </div>
                            <div className="col-10">
                                <Multiselect
                                    options={this.state.days} 
                                    selectedValues={this.state.selectedDays} 
                                    onSelect={this.onSelect.bind(this)} 
                                    onRemove={this.onRemove.bind(this)} 
                                    displayValue="name"
                                    showCheckbox={true} 
                                />
                            </div>
                        </div>
                        <div className="row" style={{ marginTop: "5px"}}>
                            <div className="col-2">
                                { couterpart.translate('shipping_calendar_duration') }:
                            </div>
                            <div className="col-10">
                                <input name="duration" type="number" size="40"
                                    placeholder="" value={this.state.duration}
                                    onChange={this.handleChange.bind(this)}/>
                            </div>
                        </div>
                        <div className="row" style={{ marginTop: "5px"}}>
                            <div className="col-2">
                                { couterpart.translate('shipping_calendar_shipTo') }:
                            </div>
                            <div className="col-10">
                                <input name="shipTo" size="40"
                                    placeholder="" value={this.state.shipTo}
                                    onChange={this.handleChange.bind(this)}/>
                            </div>
                        </div>
                        <div className="row" style={{ marginTop: "5px"}}>
                            <div className="col-12">
                                <button  className="myButton" onClick={this.handleSave.bind(this)}>
                                    <FaRegSave color={ICON_COLOR}/>{ couterpart.translate('button_save') }
                                </button>
                            </div>
                        </div>
                    </div>    
                </div>
                <ToastsContainer store={ToastsStore} position="bottom_center" />
            </div>
        );
    }
}

export default ShippingCalendar;
